import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  Output,
  EventEmitter,
} from "@angular/core";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-employee-modal",
  templateUrl: "./employee-modal.component.html",
  styleUrls: ["./employee-modal.component.scss"],
})
export class EmployeeModalComponent implements OnInit {
  @Input() employees: any[];
  filteredEmployees: any[];
  searchQuery: string;
  selectedEmployee: any;

  @Output() selectedEmployeeChange = new EventEmitter<any>();

  constructor(private modalService: NgbModal) {}

  ngOnInit(): void {
    // Initially, show all employees
    this.filteredEmployees = this.employees;
  }

  // Function to filter employees based on searchQuery
  filterEmployees() {
    if (!this.searchQuery) {
      // If search query is empty, show all employees
      this.filteredEmployees = this.employees;
    } else {
      // Filter employees based on search query
      this.filteredEmployees = this.employees.filter((employee) =>
        (employee.first_name + " " + employee.last_name)
          .toLowerCase()
          .includes(this.searchQuery.toLowerCase())
      );
    }
  }

  // Function to select an employee
  selectEmployee(employee: any) {
    // Set the selected employee
    this.selectedEmployee = employee;
    this.selectedEmployeeChange.emit(employee); // Emit selected employee to parent component

    // Push selected employee to local storage
    localStorage.setItem("selectedEmployee", JSON.stringify(employee));

    // You can perform other actions here when an employee is selected
    console.log("Selected Employee:", employee);

    // Close the modal after selecting an employee
    this.modalService.dismissAll();
  }
}
